import { ref, watch } from "vue";

const templateId = ref<string | null>(localStorage.getItem("selectedTemplateId"));

watch(templateId, (newId) => {
  if (newId) {
    localStorage.setItem("selectedTemplateId", newId);
  } else {
    localStorage.removeItem("selectedTemplateId");
  }
});

export function useTemplateStore() {
  return {
    templateId: templateId,
    setTemplateId: (id: string | null) => (templateId.value = id),
    clearTemplateId: () => (templateId.value = null),
  };
}
